import { z } from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { Foreclosure } from '../loan/Foreclosure';
import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

const ForeclosureEvent = Foreclosure.pick({
  status: true,
  referralDate: true,
  firstLegalActionDate: true,
  lawFirm: true,
  attorneyName: true,
  attorneyPhone: true,
  endOutcome: true,
  endDate: true,
}).extend({
  foreclosureId: ForeclosureId.optional(),
});

export const UpsertForeclosureEvent = BaseLoanEvent.extend({
  type: z.literal('setLoanStatusForeclosure'),
  ...ForeclosureEvent.shape,
  stopSettings: StopSettings.optional(),
  previousStopSettings: StopSettings.optional(),
});
export type UpsertForeclosureEvent = z.infer<typeof UpsertForeclosureEvent>;
